export enum Process {
  Natural = 1,
  Washed = 2,
  HoneyProcess = 3,
  Other = 4,
}

export const ProcessString = {
  [Process.Natural]: 'inventory.processnatural',
  [Process.Washed]: 'inventory.processwashed',
  [Process.HoneyProcess]: 'inventory.processhoney',
  [Process.Other]: 'inventory.processother',
}
